<template>
  <v-container
    fluid
  >

      <!--
       <pre>
       {{ this.$store.state.roiServiceFilter }}
       </pre>
       -->


       <v-row
         v-if="this.$store.state.roiStepsValid[currentRoiGroup].hasData"
       >
         <v-col style="position: relative;">
           <div v-if="loading" class="step-loading"></div>
           <form-generator :schema="schemaService"
                           v-model="formData">
           </form-generator>

           <v-alert
             v-if="!valid && showValidation"
             dense
             outlined
             type="error"
           >
             {{ this.$store.state.roiStepsValid[currentRoiGroup].msg }}
           </v-alert>
         </v-col>
       </v-row>

     </v-container>

   </template>

   <script>

   import {mapState} from "vuex";
   import FormGenerator from "./FormGenerator";

   export default {
     name: "Step.vue",
     components: { FormGenerator },
     props: [
       'currentStep',
       'currentRoiGroup',
       'validateMe'
     ],
     data () {
       return {
         schema: [],
         showValidation: false
       }
     },
     created() {
       if (this.validateMe !== '') {
         this.showValidation = true;
       }
       this.validation();
     },
     computed: {
       loading: function() {
         return this.$store.state.roiStepsLoadingStatus[this.currentRoiGroup];
       },
       formData: {
         get () {
           let getMe = this.$store.state.roiStepsValues[this.currentRoiGroup][0];
           if (typeof getMe !== 'undefined') {
             return getMe;
           }
           return {}
         },
         set (value) {
           //console.log('set change');
           this.$store.dispatch('updateRoiStepsValues', {[this.currentRoiGroup]:[value]}).then(() => {
               this.$store.commit('SET_ROI_CURRENT_STEP', this.currentStep)
               this.$store.dispatch('forceSchemaUpdate', this.currentStep);
           });


         }
       },
       valid: function () {
         return this.$store.state.roiStepsValid[this.currentRoiGroup].valid
       },
       ...mapState({
         roiGroups: state => state.roiGroups,
         roiStepsValues: state => state.roiStepsValues,
         schemaService (state) {
           let currentSchema = [];
           switch (this.currentStep) {
             case 1:
               currentSchema =  state.roiStepsSchema1
               break;
             case 2:
               currentSchema =  state.roiStepsSchema2
               break;
             case 3:
               currentSchema =  state.roiStepsSchema3
               break;
             case 4:
               currentSchema =  state.roiStepsSchema4
               break;
           }
           return currentSchema;
         }
       })
     },
     methods: {
       validation() {

         let valid = false;
         let msg = this.$t('validation.notEmpty');


         switch (this.currentStep) {
           case 1:
             for (let prop in this.formData) {
               if(this.formData[prop].length > 0) {
                 valid = true;
               }
             }
             break;
           case 2:
             for (let prop in this.formData) {
               if(this.formData[prop].length > 0) {
                 valid = true;
               }
             }
             break;
           case 3:
             for (let prop in this.formData) {
               if(this.formData[prop].length > 0) {
                 valid = true;
               }
             }
             break;
           case 4:
             for (let prop in this.formData) {
               if(this.formData[prop].length > 0) {
                 valid = true;
               }
             }
         }

         this.$store.commit('SET_ROI_STEPS_VALID_STATUS', {
           group: this.currentRoiGroup,
           valid: valid,
           msg: msg
         })



       },
     },
     watch: {
       validateMe: {
         handler() {
           this.showValidation = true;
         }
       },

       formData: {
         deep: true,
         handler() {
           this.validation();
         }
       },
     },
   }
   </script>

   <style lang="scss">

   @import '../../src/sass/variables.scss';

   .step-loading {
     position: absolute;
     height: 100%;
     width: 100%;
     background-image: url('~@/assets/background-loader.svg');
     background-position: center;
     background-size: 30%;
     background-color: rgba(245,245,245,0.6);
     z-index: 1;
   }

   .no-padding {
     padding: 0;
   }

   </style>
